import React, {Component} from 'react';
import server from '../../server';
import CepInput from '../../inputs/CepInput';
import AgencyInput from '../../inputs/AgencyInput';
import AccountInput from '../../inputs/AccountInput';
import {FisioterapistsAgenda} from './FisioterapistAccount';
import TelephoneInput from '../../inputs/TelephoneInput';

class Details extends Component{
    render(){
        return(
            <div class="col-md-12 m-0" style={{display:"flex"}}>
                <div class="col-md-6 p-0" style={{margin:"auto"}}>
                    <div class="form-group col-md-12">
                        <label for="inputName">Nome</label>
                        <input onChange={this.props.onChange} value={this.props.data.name} id="name" class="form-control" name="inputName" placeholder="Nome" required="" type="text"/>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="inputEmail">E-mail</label>
                        <input onChange={this.props.onChange} value={this.props.data.email} id="email" class="form-control" name="inputEmail" placeholder="E-mail" required="" type="email"/>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputCPF">CPF</label>
                        <input disabled value={this.props.data.cpf} id="cpf" class="form-control" name="inputCPF" placeholder="CPF" required="" type="text"/>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputPhone">Telefone</label>
                        <TelephoneInput onChange={this.props.onChange} value={this.props.data.telephone} id="telephone" class="form-control" name="inputPhone" placeholder="Telefone" required="" type="text"/>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputPhone">Data Nascimento</label>
                        <input onChange={this.props.onChange} value={this.props.data.birthDate} id="birthDate" class="form-control" name="inputBirthdate" placeholder="Data de Nascimento" required="" type="date"/>
                    </div>

                    <div class="form-group col-md-12 p-0">
                        <div class="form-group col-sm-3">
                            <label for="inpuBank">Banco</label>
                            <select class="form-control" id="bankId" value={this.props.data.bankId} onChange={this.props.onChange}>
                                <option value={0}>Selecione um Banco</option>
                                <option value={1}>Banco do Brasil</option>
                                <option value={2}>Caixa</option>
                                <option value={3}>Itaú</option>
                                <option value={4}>Santander</option>
                        </select>
                        </div>
                        <div class="form-group col-sm-3">
                            <label for="inpuAgency">Agência</label>
                            <AgencyInput onChange={this.props.onChange} value={this.props.data.bankAgency} id="bankAgency" class="form-control" name="inpuAgency" placeholder="Agência" required="" type="text"/>
                        </div>
                        <div class="form-group col-sm-6">
                            <label for="inpuAccount">Conta</label>
                            <AccountInput onChange={this.props.onChange} value={this.props.data.bankAccount} id="bankAccount" class="form-control" name="inpuAccount" placeholder="Conta" required="" type="text"/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class Address extends Component{
    render(){
        return(
            <div class="col-md-12 m-0" style={{display:"flex"}}>
                <div class="col-md-6 p-0" style={{margin:"auto"}}>
                    <div class="form-group col-md-4">
                        <label for="inputCep">CEP</label>
                        <CepInput class="form-control" onChange={this.props.onChange} value={this.props.data.cep} id="cep" name="inputCep" placeholder="cep" required="" type="text"/>
                    </div>
                    <div class="form-group col-md-5">
                        <label for="inputStreet">Endereço</label>
                        <input onChange={this.props.onChange} value={this.props.data.street} id="street" class="form-control" name="inputStreet" placeholder="Endereço" required="" type="text"/>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="inputNumber">Número</label>
                        <input class="form-control" onChange={this.props.onChange} value={this.props.data.number} id="number" name="inputNumber" placeholder="Numero" required="" type="text"/>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="inputComplement">Complemento</label>
                        <input onChange={this.props.onChange} value={this.props.data.complement} id="complement" class="form-control" name="inputComplement" placeholder="Complemento" required="" type="text"/>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="inputNeighborhood">Bairro</label>
                        <input onChange={this.props.onChange} value={this.props.data.neighborhood} id="neighborhood" class="form-control" name="inputNeighborhood" placeholder="Bairro" required="" type="text"/>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="inputCity">Cidade</label>
                        <input onChange={this.props.onChange} value={this.props.data.city} id="city" class="form-control" name="inputNeighborhood" placeholder="Bairro" required="" type="text"/>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputState">UF</label>
                        <input onChange={this.props.onChange} value={this.props.data.uf} id="uf" class="form-control" name="inputState" placeholder="Estado" maxlength="2" required="" type="text"/>
                    </div>
                </div>
            </div>
        )
    }
}

class CategoryBar extends Component{
    getLabels = () =>{
        let html = [];
        this.props.labels.forEach((label, index) => {
            html.push(
                <div style={{cursor:"pointer"}} onClick={()=> this.props.setPage(index)} class="peers ai-c mX-5">
                    <span class={this.props.page != index ? "step-number mX-5 p-5 bgc-client-secondary c-client-default-inverse" : "step-number mR-5 p-5 bgc-client-default c-client-default-inverse"}>{index + 1}</span>
                    <span class={this.props.page == index ? "c-client-default step-text" : "c-client-secondary step-text"}>
                        {label}
                    </span>
                </div>)
        })
        return html;
    }
    
    render(){
        let html = this.getLabels()
        return(
            <div class="col-md-12 peers jc-c pY-10 bdB">
                {html}
            </div>)
    }
}

class Account extends Component{
    constructor(props){
        super(props);
        this.state = {page: 0, intervals0:{}, intervals1:{}};
    }

    componentWillMount = () => {
        const user = server.user;
        const clinic = server.clinic;
        const userType = server.userType;


        let newState = this.state;

        for(let key in user){
          newState[key] = user[key]
        }

        for(let key in clinic){
          newState["c_"+key] = clinic[key]
        }

        newState["homeEnabled"] = false;
        newState["clinicEnabled"] = false;

        newState["type"] = userType;

        if(userType == "fisioterapist"){
            newState["intervals"] = null //JSON.parse(user["intervals"].replace(/'/g,'"'));

            if(newState["intervals"])
                Object.keys(newState["intervals"]).forEach((key) =>{
                    if(0 == parseInt(key.split("-")[0]))
                        newState["homeEnabled"] = true;
                
                    if(1 == parseInt(key.split("-")[0]))
                        newState["clinicEnabled"] = true;
                });

            if(newState["homeAppointmentLength"] == null) newState["homeAppointmentLength"] = 60;
            if(newState["clinicAppointmentLength"] == null) newState["clinicAppointmentLength"] = 60;
        }
        this.setState(newState);
    }

    updateState = (event) =>{
        if(event.persist)
            event.persist();
        this.setState({[event.target.id]:event.target.value}, () => console.log(this.state))
    }

    updateFile = (event) =>{
        this.setState({image:event.target.files[0]}, () => console.log(this.state))
    }

    register = () =>{
        this.setState({page:0});

        let user = {...server.user, ...this.state}

        Object.keys(user).forEach(element => {
            user[element] = this.state[element]
        });

        let correctedInterval = {};
        // CHECK INTERVALS FOR NO HOURS
        for(let i = 0; i < 2; i++){
            Object.keys(this.state["intervals" + i]).forEach((key) =>{
                let line = this.state["intervals" + i][key];
                let split = line.split("-");

                split.forEach((hour, i) =>{
                    if(hour == "SEMHORARIO"){
                        let newHour = split[i + 1];

                        if(i != 0) newHour = split[i - 1];

                        let end = parseInt(newHour.split(":")[1]) + 1;
                        end = end < 10 ? "0" + end : end;

                        split[i] = newHour.split(":")[0] + ":" + end;
                    }
                });

                correctedInterval[key] = split.join("-");
            })
        }

        user["intervals"] = JSON.stringify(correctedInterval);

        // Adjusting data
        if(typeof(user["cpf"]) === "string"){
            user["cpf"] = user["cpf"].replace(/\./g, '').replace(/\-/,'')
        }
        if(typeof(user["telephone"]) === "string"){
            user["telephone"] = user["telephone"].replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'')
        }

        if(typeof(user["cep"]) === "string"){
            user["cep"] = user["cep"].replace("-","");
        }

        var fileReader = new FileReader( );

        fileReader.onload = (data) => this.sendData(user,data);
        if(this.state.image != null)
            fileReader.readAsDataURL(this.state.image);
        else
            this.sendData(user, null);
    }

    sendData = (user, data) =>{
        // Saving new info to localStorage
        if(data) user["profilePicture"] = data.target.result.split(",")[1];

        server.user = user;

        // Creating and retrieving the response
        server.put("users/" + server.user.id, user, (data) =>{
            if(data.id == null)
                this.props.alert("Erro...","Tente novamente mais tarde","error");

            server.user = data;
            this.props.alert("Sucesso!","Dados atualizados com sucesso","success");
        });
    }

    render(){
        if(this.state.cep && typeof(this.state.cep) == "string"){
            let cepNumber = this.state.cep.replace(/\-/,"").replace(/\_/,"")
            if(cepNumber.length == 8){
                if(!this.state.cep_loaded){
                        fetch(server.address + "/cep/" + cepNumber,{
                                method: "GET"
                        }).then(response => response.json().then(data => {
                                this.setState({street:data.endereco,neighborhood:data.bairro,uf:data.uf,city:data.cidade})
                        }))
                        this.setState({cep_loaded:true})
                }
            }else{
                if(this.state.cep_loaded){
                        this.setState({cep_loaded:false})
                }
            }
        }

        const commonPages = [
            <Details data={this.state} onChange={this.updateState}/>,
            <Address data={this.state} onChange={this.updateState}/>
        ]
        const specificPages = {
            fisioterapist:[
                <FisioterapistsAgenda data={this.state} onChange={this.updateState}/>],
            secretary:[
            ],
            doctor:[
            ],
            patient:[
            ]
        }

        let pages = [...commonPages, ...specificPages[server.userType]]

        const commonLabels = ["Dados Pessoais", "Endereço"]
        const specificLabels = {
            "fisioterapist": ["Meus Horarios"],
            "doctor":[],
            "secretary":[],
            "patient":[]
        }

        let labels = [...commonLabels, ...specificLabels[server.userType]]

        return(
            <div class="col1-app">
                <div class="col1-app__wrapper">
                    <div class="col1-list h-100p">
                        <div class="peers w-100p ai-c jc-sb content-header">
                            <div class="content-header__left">
                                <div class="content-header__title">
                                    <h3 class="m-0">
                                        Minha conta
                                    </h3>
                                </div>
                            </div>
                            <div class="btn-group" role="group">
                                <button class="open-details btn btn-clear pX-5 pY-0 bdrs-2 mR-5 cur-p  c-client-default" type="button">
                                    <i class="fa fa-refresh fsz-xl"></i>
                                </button>
                            </div>
                        </div>

                        <CategoryBar 
                            page={this.state.page}
                            setPage={(page) => this.setState({page:page})}
                            labels={labels} />

                        <div class="scrollable h-100p" style={{marginBottom:50}}>
                            <div class="pT-20 pB-0 peers ai-c jc-c">
                                <img class="w-10r bdrs-50p user-image bdc-client-default" src={server.profileImage} alt=""/>
                                <div class="bgc-white peers ai-c jc-c bd bdrs-50p bdc-client-default p-2 change-picture">
                                    <i class="fa fa-camera c-client-default fsz-md"></i>
                                </div>
                                <input onChange={this.updateFile} id="profilePicture" type="file"/>
                            </div>
                            
                            <div class="content-data">
                                {pages[this.state.page]}
                            </div>
                        </div>

                        <div style={{bottom:0, width:"100%"}} class="bdT p-10 peers jc-sb ai-c bgc-client-default">
                            <div class="peers ai-c">
                                <span class="step-number bgc-pink-500 c-white mL-10">{this.state.page + 1}</span>
                                <div class="mL-10">
                                    <h4 class="m-0 c-client-default-inverse fsz-sm">{labels[this.state.page]}</h4>
                                </div>

                            </div>

                            <button onClick={this.state.page == pages.length - 1 ? this.register : () => this.setState({page:(this.state.page + 1)%pages.length})} class="another-data open-details btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default-inverse fsz-md"
                                type="button">
                                {this.state.page == pages.length - 1 ? "Enviar" : labels[(this.state.page + 1)%labels.length]}
                                <i class="fa fa-angle-right fsz-xl"></i>
                            </button>
                        </div>
                    </div>
                </div>


                <div class="col1-app__side-details jc-fs bdL bgc-white mobile-scroll">
                    <div class="inner-content mobile-scroll__inner">
                        <div>
                        <button type="button" class="open-details open-details btn btn-clear pX-5 pY-0 pos-a t-20 l-10 bdrs-2 cur-p c-client-secondary">
                            <i class="material-icons">close</i>
                        </button>
                        <div class="w-100p ta-c mT-20">
                            <div class="fsz-xs c-client-default">Seu horário</div>
                            <h3 class="ta-c m-0">Atendimento</h3>


                            <hr class="small bdc-client-default mY-10 pX-10"/>
                        </div>
                        <div class="form-group col-md-12 p-0">
                            <div class="col-sm-12 m-0 p-10 peers jc-c">
                                <div class="col-sm-6 m-0 p-0">
                                    <div class="checkbox checkbox-client-default">
                                        <input id="segunda" type="checkbox"/>
                                        <label for="segunda">Segunda-feira</label>
                                    </div>

                                    <div class="checkbox checkbox-client-default">
                                        <input id="terca" type="checkbox"/>
                                        <label for="terca">Terça-feira</label>
                                    </div>

                                    <div class="checkbox checkbox-client-default">
                                        <input id="quarta" type="checkbox"/>
                                        <label for="quarta">Quarta-feira</label>
                                    </div>

                                    <div class="checkbox checkbox-client-default">
                                        <input id="quinta" type="checkbox"/>
                                        <label for="quinta">Quinta-feira</label>
                                    </div>
                                </div>
                                <div class="col-sm-6  m-0 p-0">
                                    <div class="mL-20">
                                        <div class="checkbox checkbox-client-default">
                                            <input id="sexta" type="checkbox"/>
                                            <label for="sexta">Sexta-feira</label>
                                        </div>

                                        <div class="checkbox checkbox-client-default">
                                            <input id="sabado" type="checkbox"/>
                                            <label for="sabado">Sábado</label>
                                        </div>

                                        <div class="checkbox checkbox-client-default">
                                            <input id="domingo" type="checkbox"/>
                                            <label for="domingo">Domingo</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class=" col-sm-12 m-0 p-10">
                                <div class="col-md-12 mB-20 p-0 peers w-100p jc-c">

                                    <div>
                                        <div class="form-group  m-0 pR-10 pL-0 col-lg-12">
                                            <label>Consulta na clínica</label>
                                        </div>
                                        <div class="form-group  m-0 pR-10 pL-0 col-xs-4 time-input">
                                            <label class="c-client-secondary fsz-xs  m-0">H. inicial</label>
                                            <input class="form-control" name="inputTime" required="" type="time"/>
                                        </div>

                                        <div class="form-group  m-0 pR-10 pL-0 col-xs-4 time-input">
                                            <label class="c-client-secondary fsz-xs  m-0">H.final
                                                <input class="form-control" name="inputTime" required="" type="time"/>
                                            </label>
                                        </div>
                                        <div class="form-group  m-0 pR-10 pL-0 col-xs-4 time-input">
                                            <label class="c-client-secondary fsz-xs  m-0">Tempo </label>
                                            <input class="form-control" name="inputTime" required="" type="time"/>
                                        </div>
                                    </div>

                                </div>
                                <div class="clearfix"></div>
                                <div class="col-md-12 mB-20 p-0  peers w-100p jc-c">
                                    <div>
                                        <div class="form-group  m-0 pR-10 pL-0 col-lg-12">
                                            <label>Consulta domiciliar</label>
                                        </div>
                                        <div class="form-group  m-0 pR-10 pL-0 col-xs-4 time-input">
                                            <label class="c-client-secondary fsz-xs m-0">H. inicial</label>
                                            <input class="form-control" name="inputTime" required="" type="time"/>
                                        </div>

                                        <div class="form-group  m-0 pR-10 pL-0 col-xs-4 time-input">
                                            <label class="c-client-secondary fsz-xs  m-0">H.final
                                                <input class="form-control" name="inputTime" required="" type="time"/>
                                            </label>
                                        </div>
                                        <div class="form-group  m-0 pR-10 pL-0 col-xs-4 time-input">
                                            <label class="c-client-secondary fsz-xs  m-0">Tempo </label>
                                            <input class="form-control" name="inputTime" required="" type="time"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="col-md-12 action-button">
                                    <div class="peers jc-c ai-c mT-10">
                                        <button class="open-details btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default" type="button">
                                            <i class="fa fa-plus-circle fsz-xl mR-10"></i>
                                            Adicionar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}

export default Account



// WEBPACK FOOTER //
// ./src/pages/account/Account.js